<ng-container *ngIf="isLBA">
    <mat-card>
        <div
            *ngIf="!recordView && !createClientView"
            [ngClass]="{
                'disable-for-quickview': quickview,
                '': !quickview
            }"
        >
            <div class="settings-heading">Clients</div>
            <div class="padding-16-top-bottom client-controll-area">
                <div class="client-search-box-area">
                    <mat-form-field fluid appearance="outline" class="example-full-width">
                        <mat-label>Find Client</mat-label>

                        <input
                            matInput
                            [(ngModel)]="clientSearchTerm"
                            class="search-field"
                            #clientSearchBox
                            (ngModelChange)="updateGrid()"
                            [ngModelOptions]="{ standalone: true }"
                        />
                        <mat-icon matSuffix>search</mat-icon>
                    </mat-form-field>
                </div>

                <div class="client-export-button-area">
                    <span
                        (click)="exportToExcel(grid)"
                        title="Download Excel"
                        class="client-export-button"
                    >
                        <mat-icon fontSet="fas" fontIcon="fa-file-excel"></mat-icon>
                    </span>
                </div>
                <div class="client-add-button-area">
                    <button type="button" mat-raised-button (click)="addClientHandler()">
                        <i class="fal fa-plus-square"></i>
                        &nbsp; ADD CLIENT
                    </button>
                </div>
            </div>

            <div>
                <kendo-grid
                    #grid="kendoGrid"
                    class="lg-kendo-grid"
                    [data]="gridView"
                    [loading]="loading"
                    (cellClick)="handleCellClick($event)"
                    [pageSize]="pageSize"
                    [skip]="skip"
                    [height]="635"
                    [sortable]="{
                        mode: 'single',
                        allowUnsort: false
                    }"
                    [sort]="clientSort"
                    (sortChange)="sortChange($event)"
                    [pageable]="{
                        info: true,
                        type: type,
                        pageSizes: true,
                        previousNext: true
                    }"
                    [scrollable]="'scrollable'"
                    (pageChange)="clientPageChange($event)"
                >
                    <ng-template kendoGridNoRecordsTemplate>
                        <div class="no-data-message-area" *ngIf="noClients">
                            <no-data-screen [noDataType]="noDataType"> </no-data-screen>
                        </div>
                    </ng-template>
                    <kendo-grid-column
                        field="clientKey"
                        title="CLIENT ID"
                        [width]="130"
                        [headerClass]="'client-grid-header'"
                        [headerStyle]="{ 'text-align': 'left' }"
                        [class]="'text-color-black'"
                        [style]="{ 'text-align': 'left' }"
                    >
                    </kendo-grid-column>
                    <kendo-grid-column
                        field="fullName"
                        title="CLIENT NAME"
                        [width]="350"
                        [headerClass]="'client-grid-header'"
                        [headerStyle]="{ 'text-align': 'left' }"
                        [class]="'text-color-black'"
                        [style]="{ 'text-align': 'left' }"
                    >
                    </kendo-grid-column>
                    <kendo-grid-column
                        field="shortName"
                        title="SHORT"
                        [width]="190"
                        [headerClass]="'client-grid-header'"
                        [headerStyle]="{ 'text-align': 'left' }"
                        [class]="'text-color-black'"
                        [style]="{ 'text-align': 'left' }"
                    >
                    </kendo-grid-column>
                    <kendo-grid-column
                        field="subscriptionType"
                        title="ENROLLMENTS"
                        [width]="140"
                        [headerClass]="'client-grid-header'"
                        [headerStyle]="{ 'text-align': 'left' }"
                        [class]="'text-color-black'"
                        [style]="{ 'text-align': 'left' }"
                        [footerClass]="'text-color-black'"
                        [footerStyle]="{ 'text-align': 'left' }"
                    >
                    </kendo-grid-column>
                    <kendo-grid-column
                        title="STATUS"
                        [width]="105"
                        [headerClass]="'client-grid-header'"
                        [headerStyle]="{ 'text-align': 'left' }"
                        [class]="'text-color-black'"
                        [style]="{ 'text-align': 'left' }"
                        [footerClass]="'text-color-black'"
                        [footerStyle]="{ 'text-align': 'left' }"
                    >
                        <ng-template kendoGridCellTemplate let-record>
                            <div>
                                {{
                                    calculateStatus(
                                        record.activeDate,
                                        record.inActiveDate,
                                        record.isActive
                                    )
                                }}
                            </div>
                        </ng-template>
                    </kendo-grid-column>
                    <kendo-grid-column
                        field="goLiveDate"
                        title="LAUNCH DATE"
                        [width]="130"
                        [headerClass]="'client-grid-header'"
                        [headerStyle]="{ 'text-align': 'left' }"
                        [class]="'text-color-black'"
                        [style]="{ 'text-align': 'left' }"
                        [footerClass]="'text-color-black'"
                        [footerStyle]="{ 'text-align': 'left' }"
                    >
                        <ng-template kendoGridCellTemplate let-record>
                            <div>
                                {{ record.goLiveDate | date: 'MM/dd/yyyy':'UTC' }}
                            </div>
                        </ng-template>
                    </kendo-grid-column>
                    <kendo-grid-column
                        field="activeDate"
                        title="ACTIVE"
                        [width]="130"
                        [headerClass]="'client-grid-header'"
                        [headerStyle]="{ 'text-align': 'left' }"
                        [class]="'text-color-black'"
                        [style]="{ 'text-align': 'left' }"
                        [footerClass]="'text-color-black'"
                        [footerStyle]="{ 'text-align': 'left' }"
                    >
                        <ng-template kendoGridCellTemplate let-record>
                            <div>
                                {{ record.activeDate | date: 'MM/dd/yyyy':'UTC' }}
                            </div>
                        </ng-template>
                    </kendo-grid-column>
                    <kendo-grid-command-column
                        title=""
                        [width]="75"
                        [headerClass]="'client-grid-header'"
                        [headerStyle]="{ 'text-align': 'left' }"
                        [class]="'text-color-black'"
                        [style]="{ 'text-align': 'left' }"
                    >
                        <ng-template kendoGridCellTemplate let-record>
                            <i class="fa fa-pencil" aria-hidden="true"></i>
                        </ng-template>
                    </kendo-grid-command-column>
                    <kendo-grid-excel [fileName]="exportFileName" [fetchData]="getExcelExportData">
                        <kendo-excelexport-column
                            field="clientKey"
                            title="CLIENT ID"
                        ></kendo-excelexport-column>
                        <kendo-excelexport-column
                            field="fullName"
                            title="CLIENT NAME"
                        ></kendo-excelexport-column>
                        <kendo-excelexport-column
                            field="shortName"
                            title="SHORT"
                        ></kendo-excelexport-column>
                        <kendo-excelexport-column
                            field="subscriptionType"
                            title="SUBSCRIPTION"
                        ></kendo-excelexport-column>
                        <kendo-excelexport-column
                            title="STATUS"
                            field="calculatedStatus"
                        ></kendo-excelexport-column>
                        <kendo-excelexport-column
                            title="LAUNCHED DATE"
                            field="formattedGoLiveDate"
                        ></kendo-excelexport-column>
                        <kendo-excelexport-column
                            title="ACTIVE"
                            field="formattedActiveDate"
                        ></kendo-excelexport-column>
                    </kendo-grid-excel>
                    <ng-template kendoPagerTemplate>
                        <kendo-pager-prev-buttons
                            class="text-color-black"
                        ></kendo-pager-prev-buttons>
                        <kendo-pager-input class="text-color-black"></kendo-pager-input>
                        <kendo-pager-info class="text-color-black"></kendo-pager-info>
                        <kendo-pager-next-buttons
                            class="text-color-black"
                        ></kendo-pager-next-buttons>
                        <kendo-pager-page-sizes
                            class="text-color-black"
                            [pageSizes]="[5, 10, 25, 50, 100]"
                        ></kendo-pager-page-sizes>
                    </ng-template>
                </kendo-grid>
            </div>
        </div>
        <div
            id="admin-background"
            *ngIf="isSideViewOpen && quickview"
            class="quickview client-edit-screen"
        >
            <!--                    [clientShortName]="clientShortName"-->
            <ng-container>
                <client-edit-screen
                    [action]="action"
                    [clientModel]="selectedClientFullModel"
                    (updatePage)="updatePageFromSideBar()"
                ></client-edit-screen>
            </ng-container>
        </div>
        <div
            [ngClass]="{ 'middle-layer-for-page-disable': quickview }"
            (click)="handleCancelClicked()"
        ></div>
        <div style="width: 100%">
            <!-- TODO: Is this section using ever?? seems like 'recordView' is always false-->
            <ng-container *ngIf="recordView" style="width: 100%">
                <app-company-account-details
                    [companyFullModel]="selectedClientFullModel"
                    (cancelClickedEvent)="handleCancelClicked()"
                ></app-company-account-details>
            </ng-container>
        </div>
    </mat-card>
</ng-container>
